export const handleGenerateDateSlot = (location, locationId) => location?.find((location) => location.Id?.replace(/{|}/g, '') === locationId)?.['Date Slot'];
